import request from '@/utils/request'

// 해지 신청 목록 조회
export function getCancelManage(params, isNotify) {
  return request({
    url: `/api/getCancelManage`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 해지 승인
export function approveCancelManage(params, isNotify) {
  return request({
    url: `/api/approveCancelManage`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}

// 해지 정보 조회
export function getCancelInfo(params, isNotify) {
  return request({
    url: `/api/getCancelInfo`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}


// 해지 요약 정보 조회
export function getCancelSummary(params, isNotify) {
  return request({
    url: `/api/getCancelSummary`,
    method: 'GET',
    params: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}